import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import urlJoin from 'url-join';

@Injectable({ providedIn: 'root' })
export class AiDocumentsService {
  private http = inject(HttpClient);

  upload(data: FormData) {
    return this.http.post(urlJoin(environment.apiUrl, '/ai-documents'), data);
  }
}
